<template>
    <div class="about">
      <TransitionGroup>
        <div class="card mx-auto my-5 shadow" style="min-width: 18rem; max-width: fit-content;overflow: auto;" v-if="showModal">
          <div class="card-body">
            <h5 class="card-title">
               Billable Data
            </h5>
            <button type="button" class="btn-close position-absolute fs-4" aria-label="Close" style="right: 5px;top: 5px;" @click.prevent="showModal=false"></button>
            <div class="contain">
              <div class="row" v-for="r,index in Object.keys(rowData).filter(item=>!formHidden.includes(item))" :key="index">
                <template v-if="r=='name'">
                  <float-inp type="text" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                  label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
                  <div class="col-12 px-1 mb-2 text-end small" :class="nameCounterClass">
                    {{ billableNameLength }}/{{ maxBillableNameLength }}
                  </div>
                </template>
                <template v-else-if="r=='description'">
                  <div class="col-12 px-1 mb-1">
                    <label class="text-dark fw-bold">{{ headers[r] }}
                      <span class="badge bg-info ms-2">this will be displayed on the invoice</span>
                    </label>
                    <textarea v-model="rowData[r]" class="form-control bg-primary-subtle bg-gradient input" :disabled="disabled.includes(r)" rows="3"></textarea>
                  </div>
                  <div class="col-12 px-1 mb-2 text-end small" :class="descriptionCounterClass">
                    {{ billableDescriptionLength }}/{{ maxBillableDescriptionLength }}
                  </div>
                </template>
                <float-select v-if="r=='type'" list-mode="Array" label="Billable Type" :options="listOptions.type" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="rowData[r]"
                  label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient"/>
                <float-select v-else-if="r=='currency'" list-mode="Array" label="Billing Currency" :options="listOptions.currency" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="listOptions.currency.find((b)=>{return b==rowData[r]})"
                    label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient"/>
                <multi-form v-else-if="r=='taxes'" :options="ddHolder.taxes" formClass="bg-primary-subtle bg-gradient input" wrapClass="col-12 px-1 mb-1"
                  label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input"  label="Taxes" :subTexts="['shortcode','perc']" :suffix="multiCols.suffix" :prefix="multiCols.prefix"
                        title="Select Taxes" :selected="rowData[r]? rowData[r] : []" @updateChoices="this.rowData[r]=$event"/>
                <float-inp v-else-if="r!='name' && r!='description'" type="text" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
              </div>
            </div>
            <button
              type="button"
              v-if="rowData['id']===null || rowData['id']<1"
              class="btn btn-primary"
              @click="onCreateClick"
            >Create Billable</button>
            <template v-else>
              <button
                type="button"
                class="btn btn-warning me-2"
                @click="onDuplicateClick"
              >Duplicate</button>
              <button
                type="button"
                class="btn btn-success me-2"
                @pointerdown.stop.prevent="onUpdateClick"
                @click.stop.prevent="onUpdateClick"
              >Update Billable</button>
              <button type="button" class="btn btn-outline-danger" @click.prevent="requestActionCaptcha({ title: 'Confirm Delete', promptText: 'Solve the sum to delete this billable record.', confirmLabel: 'Delete', action: () => deleteCurrentRecord() })">
                <i class="bi bi-trash3 me-1"></i>
                Delete
              </button>
            </template>
          </div>
        </div>
        <cdTable :links="links" title="Billables" table-name="billable" :hidden="hidden" :headers="headers" 
        :gen-form="false" v-else @popForm="e=>setRowData(e)" :multiCols="multiCols"></cdTable>
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
        
      </TransitionGroup>

      
    </div>
  </template>
  <script>
  import floatInp from '@/parts/floatInp.vue';
  import floatSelect from '@/parts/floatSelect.vue';
  import MultiForm from '@/parts/MultiForm.vue';
  import cdTable from '@/components/cddatatables/cdTable.vue';
  import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
  import { billableLinks,dropDownLinks } from '@/cd-links';  

  const MAX_BILLABLE_NAME_LENGTH = 255;
  const MAX_BILLABLE_DESCRIPTION_LENGTH = 255;

  export default{
    components:{
      cdTable, floatInp, floatSelect, MultiForm, ActionCaptchaModal
    },
    data(){
      return {
        maxBillableNameLength: MAX_BILLABLE_NAME_LENGTH,
        maxBillableDescriptionLength: MAX_BILLABLE_DESCRIPTION_LENGTH,
        links: billableLinks,
        headers:{
            id: "ID",
            name: "Billable",
            type: "Type",
            hsn:"HSN / SAC",
            taxes:"Taxes",
            description: "Description",
            shortcode: "Short Code",
            currency: "Currency",
            cost: "Cost",
            status: "Status",
            createdAt: "Created On",
            updatedAt: "Updated On",
          },
          hidden:[
            'creatorId',
            /* 'createdAt',
            'updatedAt', */
            'billable_entity.id',
            'billable_entity.name'
          ],
          disabled:['id'],
          formHidden:[
            'creatorId',
            'createdAt',
            'updatedAt',
            'status',
            'ent_id',

          ],          
          showModal:false,
          rowData:{
            id: null,
            name: null,
            type: null,
            hsn:null,
            taxes:null,
            description: null,
            shortcode: null,
            currency: null,
            cost: null,
            status: null
          },
          multiCols:{
                  cols:[
                    'taxes',
                  ],
                  subTexts:{
                    taxes:['shortcode','perc']
                  },
                  suffix:new Map([
                    ["perc","%"], 
                  ]),
                  prefix: new Map([
                    /* ["perc","Excl."] */
                  ])
                },
          preFetch:false,
          listOptions:{
            currency: ['INR','GBP','USD','EUR','RUB'],
            type: ['Service','Product','Consultancy']
          },
          ddHolder:{
            taxes:[],   
          },
          loading: false,
          showActionCaptcha: false,
          captchaTitle: 'Confirm Action',
          captchaPromptText: 'Please solve this quick check to continue.',
          captchaConfirmLabel: 'Confirm',
          pendingAction: null,
      }
    },
    computed: {
      billableNameLength() {
        return String(this.rowData?.name || '').length;
      },
      nameCounterClass() {
        if (this.billableNameLength > this.maxBillableNameLength) {
          return 'text-danger fw-bold';
        }
        if (this.billableNameLength >= Math.ceil(this.maxBillableNameLength * 0.8)) {
          return 'text-warning fw-bold';
        }
        return 'text-muted';
      },
      billableDescriptionLength() {
        return String(this.rowData?.description || '').length;
      },
      descriptionCounterClass() {
        if (this.billableDescriptionLength > this.maxBillableDescriptionLength) {
          return 'text-danger fw-bold';
        }
        if (this.billableDescriptionLength >= Math.ceil(this.maxBillableDescriptionLength * 0.8)) {
          return 'text-warning fw-bold';
        }
        return 'text-muted';
      }
    },
    methods:{
      onCreateClick() {
        this.requestActionCaptcha({
          title: 'Confirm Create',
          promptText: 'Solve the sum to create this billable record.',
          confirmLabel: 'Create',
          action: () => this.postBillable('post')
        });
      },
      onDuplicateClick() {
        this.requestActionCaptcha({
          title: 'Confirm Duplicate',
          promptText: 'Solve the sum to duplicate this billable record.',
          confirmLabel: 'Duplicate',
          action: () => this.duplicateCurrentRecord()
        });
      },
      onUpdateClick(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        this.requestActionCaptcha({
          title: 'Confirm Update',
          promptText: 'Solve the sum to update this billable record.',
          confirmLabel: 'Update',
          action: () => this.postBillable('put')
        });
      },
      requestActionCaptcha({ title, promptText, confirmLabel, action }) {
        this.captchaTitle = title || 'Confirm Action';
        this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
        this.captchaConfirmLabel = confirmLabel || 'Confirm';
        this.pendingAction = typeof action === 'function' ? action : null;
        this.showActionCaptcha = true;
      },
      closeActionCaptcha() {
        this.showActionCaptcha = false;
        this.pendingAction = null;
      },
      confirmActionCaptcha() {
        const action = this.pendingAction;
        this.showActionCaptcha = false;
        this.pendingAction = null;
        if (typeof action === 'function') action();
      },
      duplicateCurrentRecord(){
        const duplicated = JSON.parse(JSON.stringify(this.rowData || {}));
        duplicated.id = null;
        this.rowData = duplicated;
      },
      async deleteCurrentRecord(){
        if (!this.rowData?.id || this.rowData.id < 1) return;

        try {
          const resp = await this.$store.getters.getAxios(this.links.delItem, {
            method: 'delete',
            data: { id: this.rowData.id }
          });

          if (resp.data.isLoggedIn) {
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success ? 'info' : 'danger'
            });
            if (resp.data.success) this.showModal = false;
          } else {
            this.$store.dispatch('loggedOut');
          }
        } catch (err) {
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err.response?.data?.msg || err.message || 'Error deleting billable',
            type: 'danger'
          });
        }
      },
      async postBillable(mode){
        const trimmedName = String(this.rowData.name || '').trim();
        if (!trimmedName) {
          this.$store.commit('addAlert', {
            title: 'Validation Error',
            message: 'Billable name is required.',
            type: 'warning'
          });
          this.showModal = true;
          return;
        }

        if (trimmedName.length > MAX_BILLABLE_NAME_LENGTH) {
          this.$store.commit('addAlert', {
            title: 'Validation Error',
            message: `Billable name cannot exceed ${MAX_BILLABLE_NAME_LENGTH} characters.`,
            type: 'warning'
          });
          this.showModal = true;
          return;
        }

        if (this.billableDescriptionLength > MAX_BILLABLE_DESCRIPTION_LENGTH) {
          this.$store.commit('addAlert', {
            title: 'Validation Error',
            message: `Description cannot exceed ${MAX_BILLABLE_DESCRIPTION_LENGTH} characters.`,
            type: 'warning'
          });
          this.showModal = true;
          return;
        }

        try {
          this.loading=true;
          this.rowData.status=true;
          this.rowData.name = trimmedName;
          this.rowData['ent_id']=this.$store.getters.getEntity;
          this.rowData.taxes = this.normalizeSelectedTaxes(this.rowData.taxes);

          const resp = await this.$store.getters.getAxios(this.links[mode],{method:mode,data:this.rowData});

          if(resp.data.isLoggedIn){
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success? 'info' : 'danger'
            });
            this.showModal = !resp.data.success;
          }
          else {
            this.$store.dispatch('loggedOut');
          }
        } catch(err){
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err?.response?.data?.msg || err?.message || 'Error saving billable data',
            type: 'danger'
          });
          this.showModal = true;
        } finally {
          this.loading = false;
        }
      },
      setRowData(e){
        this.rowData={...e.rowData};
        this.rowData.taxes = this.normalizeSelectedTaxes(this.rowData.taxes);
        this.showModal=true;
      },
      normalizeSelectedTaxes(taxes) {
        let parsed = taxes;

        if (typeof parsed === 'string') {
          try {
            parsed = JSON.parse(parsed);
          } catch (_) {
            parsed = [];
          }
        }

        if (!Array.isArray(parsed)) {
          return [];
        }

        return parsed.map((tax) => {
          if (tax == null || typeof tax !== 'object') {
            return tax;
          }

          const selectedId = Number(tax.id);
          const sourceTax = this.ddHolder.taxes.find((opt) => Number(opt.id) === selectedId);

          return {
            id: tax.id,
            name: tax.name ?? sourceTax?.name ?? null,
            perc: tax.perc ?? sourceTax?.perc ?? null,
            shortcode: tax.shortcode ?? sourceTax?.shortcode ?? null,
          };
        });
      },
      async getDropDownData(table,listName,filter) {
                    this.loading=true;
                    await this.$store.getters.getAxios.post(dropDownLinks[table],{ent_id:this.$store.getters.getEntity,filter:filter})
                        .then(resp=>{
                            if(!resp.data.isLoggedIn){
                                this.$store.dispatch('loggedOut');
                            }
                            else {
                              this.ddHolder[listName] =  resp.data.data;
                              if (listName === 'taxes') {
                                this.rowData.taxes = this.normalizeSelectedTaxes(this.rowData.taxes);
                              }
                            }
                        })
                        // eslint-disable-next-line
                        .catch(err=>{
                            this.$store.commit('addAlert', {
                                title: "Error Getting DropDown Data for "+listName,
                                message: "Try after some time",
                                type: 'danger'
                            });
        
                        });
      }
    },
    async mounted(){
      await this.getDropDownData('taxes','taxes',0);
    }
}
  </script>
  